import { LoginLayout } from "../../layouts";

export const LoginPage = () => {
  return (
    <>
      <LoginLayout />
    </>
  );
};
